/*
Language: LDIF
Contributors: Jacob Childress <jacobc@gmail.com>
Category: enterprise, config
Website: https://en.wikipedia.org/wiki/LDAP_Data_Interchange_Format
*/
function ldif(hljs) {
  return {
    name: 'LDIF',
    contains: [{
      className: 'attribute',
      begin: '^dn',
      end: ': ',
      excludeEnd: true,
      starts: {
        end: '$',
        relevance: 0
      },
      relevance: 10
    }, {
      className: 'attribute',
      begin: '^\\w',
      end: ': ',
      excludeEnd: true,
      starts: {
        end: '$',
        relevance: 0
      }
    }, {
      className: 'literal',
      begin: '^-',
      end: '$'
    }, hljs.HASH_COMMENT_MODE]
  };
}

module.exports = ldif;